import React, { Component } from "react";
import { Button, TextArea, Form, Segment, Message, Icon } from 'semantic-ui-react';
import axios from 'axios';

class ChatComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prompt: "",
      searchProcess: false,
      chatResult: null,
      error: "",
    };
  }

  render() {
    const { prompt, searchProcess, chatResult, error } = this.state;
    return (
      <Segment padded="very" style={{ maxWidth: 500, margin: "2em auto" }}>
        <Form>
          <Form.Field>
            <label>
              <Icon name="search" /> Search for a Historical Landmark
            </label>
            <TextArea
              name="prompt"
              value={prompt}
              onChange={this.handleInputChange}
              placeholder="Please enter what historical landmark you are looking for..."
              style={{ minHeight: 80 }}
            />
          </Form.Field>
          {error && (
            <Message negative>
              <Message.Header>Error</Message.Header>
              <p>{error}</p>
            </Message>
          )}
          <Button
            type="button"
            onClick={this.handleCancelClick}
            color="grey"
            disabled={searchProcess}
            icon
            labelPosition="left"
          >
            <Icon name="cancel" />
            Cancel
          </Button>
          <Button
            type="button"
            onClick={this.handleSearchClick}
            color="blue"
            loading={searchProcess}
            icon
            labelPosition="left"
          >
            <Icon name="search" />
            Search
          </Button>
        </Form>
        {chatResult && (
          <Segment secondary style={{ marginTop: "2em" }}>
            <strong>Results:</strong>
            <pre style={{ whiteSpace: "pre-wrap" }}>
              {JSON.stringify(chatResult, null, 2)}
            </pre>
          </Segment>
        )}
      </Segment>
    );
  }

  handleInputChange = (event, data) => {
    const value = data.value;
    this.setState({ prompt: value, error: "" });
  };

  handleCancelClick = () => {
    this.setState({ prompt: "", error: "" });
    this.props.handleCancel();
  };

  handleSearchClick = () => {
    if (!this.state.prompt.trim()) {
      this.setState({ error: "Please enter a landmark to search." });
      return;
    }
    this.setState({ searchProcess: true, error: "" });
    const searchText = this.state.prompt;
    const requestData = {
      request: { "prompt": searchText }
    };
    const apiUrl = process.env.REACT_APP_CHAT_API_URL;    
    axios.post(`${apiUrl}/chat`, requestData, {
      headers: { "content-type": "application/json" }
    })
    .then((res) => this.finishSearch(res.data))
    .catch(() => this.finishSearch({ error: true }));
  };

  finishSearch(res) {
    
    this.setState({ searchProcess: false });
    if (res.error) {
      this.setState({ error: "Unable to perform the search " + JSON.stringify(res.error) });
    } else if (!res.whereClause || res.whereClause.trim() === "") {
      this.setState({ error: "No records found.", chatResult: null });
    } else {
      this.setState({ chatResult: res.whereClause, error: "" });
      this.props.handleSuccessfulSearch(res.whereClause);
    }
  }
}

export default ChatComponent;